import '@fancyapps/fancybox/dist/jquery.fancybox.css'

import 'shared/ada_tab';
import 'lib/jquery.joyride';

require('jquery-ui/ui/widget');
require('jquery-ui/ui/disable-selection');
require('jquery-ui/ui/effect');
require('jquery-ui/ui/keycode');
require('jquery-ui/ui/tabbable');
require('jquery-ui/ui/widgets/autocomplete');
require('jquery-ui/ui/widgets/datepicker');
require('jquery-ui/ui/widgets/draggable');
require('jquery-ui/ui/widgets/droppable');
require('jquery-ui/ui/widgets/slider');
require('jquery-ui/ui/widgets/sortable');

require('jquery-ui-touch-punch/jquery.ui.touch-punch.min.js');

window.Modernizr = require('modernizr');
require('foundation-sites/js/entries/foundation');
